const LOCAL_HOSTS = new Set(["localhost", "127.0.0.1"]);
const COOKIE_STORAGE_KEY = "selena_cookie_consent_v1";
const LOCAL_DEV_API_BASE = "http://localhost:8000/api";

const DEFAULT_CONSENT = {
  necessary: true,
  analytics: false,
  marketing: false,
};

function isLocalHost(hostname) {
  return LOCAL_HOSTS.has(String(hostname || "").toLowerCase()) || String(hostname || "") === "::1";
}

function isPrivateNetworkHost(hostname) {
  const host = String(hostname || "").toLowerCase();
  if (isLocalHost(host) || host.endsWith(".local")) return true;
  if (/^10\.\d+\.\d+\.\d+$/.test(host)) return true;
  if (/^192\.168\.\d+\.\d+$/.test(host)) return true;
  if (/^172\.(1[6-9]|2\d|3[0-1])\.\d+\.\d+$/.test(host)) return true;
  return false;
}

function normalizeBaseUrl(url) {
  return String(url || "").replace(/\/+$/, "");
}

/** Dacă e setat doar origin-ul (ex. http://localhost:8000), PHP-ul e sub `/api/`. */
function ensureApiFolderIfRootPath(baseUrl) {
  const trimmed = normalizeBaseUrl(baseUrl);
  try {
    const u = new URL(trimmed);
    let path = u.pathname || "/";
    path = path.replace(/\/+$/, "") || "/";
    if (path === "/") {
      u.pathname = "/api";
      return normalizeBaseUrl(u.toString());
    }
    return trimmed;
  } catch {
    return trimmed;
  }
}

export function resolveApiBaseUrl({ forTracking = false } = {}) {
  const configuredApiBaseUrl = process.env.REACT_APP_API_BASE_URL || "";
  const pageIsLocal = isLocalHost(window.location.hostname);

  if (configuredApiBaseUrl) {
    try {
      const parsed = new URL(configuredApiBaseUrl, window.location.origin);
      const targetIsPrivate = isPrivateNetworkHost(parsed.hostname);
      const mixedContentRisk = window.location.protocol === "https:" && parsed.protocol === "http:";

      // Prevent production/staging pages from calling localhost/private APIs.
      if (!pageIsLocal && (targetIsPrivate || mixedContentRisk)) {
        return `${window.location.origin}/api`;
      }
    } catch {
      // If invalid configured URL, fallback rules below.
    }

    return ensureApiFolderIfRootPath(normalizeBaseUrl(configuredApiBaseUrl));
  }

  if (pageIsLocal) {
    return forTracking ? null : LOCAL_DEV_API_BASE;
  }

  return `${window.location.origin}/api`;
}

function getApiBaseUrl() {
  return resolveApiBaseUrl({ forTracking: true });
}

function getConsentPrefs() {
  try {
    const raw = window.localStorage.getItem(COOKIE_STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return { ...DEFAULT_CONSENT, ...parsed };
  } catch {
    return null;
  }
}

export function canTrackCategory(category = "analytics") {
  if (category === "necessary") return true;
  const prefs = getConsentPrefs();
  if (!prefs) return false;
  return Boolean(prefs[category]);
}

export function getTrackingApiBaseUrl() {
  return resolveApiBaseUrl({ forTracking: true });
}

export function trackEvent(eventName, meta = {}, category = "analytics") {
  if (!canTrackCategory(category)) return;

  const apiBaseUrl = getApiBaseUrl();
  if (!apiBaseUrl) return;

  const payload = {
    event_name: eventName,
    path: window.location.pathname + window.location.search,
    lang: document.documentElement.lang || "ro",
    referrer: document.referrer || "",
    meta,
    ts: new Date().toISOString(),
  };

  fetch(`${apiBaseUrl}/event-track.php`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
    keepalive: true,
  }).catch(() => {
    // Event tracking should never affect user flow.
  });
}
